var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNotificationSmsSuccess = function SvgIconNotificationSmsSuccess(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.956,
    height: 31.996,
    viewBox: "0 0 30.956 31.996",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-830.051 -546)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(721.09 503.543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.142,105.566v10.512a2.625,2.625,0,0,0,2.622,2.621h9.523a2.625,2.625,0,0,0,2.622-2.621V97.031a2.624,2.624,0,0,0-2.622-2.621h-1.511a.505.505,0,0,0,0,1.01h1.511a1.613,1.613,0,0,1,1.611,1.611v2.14h-4.683a.505.505,0,1,0,0,1.01H197.9v12.746H185.152v-7.362a.505.505,0,0,0-1.01,0Zm1.01,10.512v-2.14H197.9v2.14a1.613,1.613,0,0,1-1.611,1.611h-9.523A1.613,1.613,0,0,1,185.152,116.078Z",
    transform: "translate(-69.363 -47.697)",
    fill: "#11526a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.034,49.3c0,2.736,2.357,5.069,5.647,5.634a3.709,3.709,0,0,0,3.614,2.955.383.383,0,0,0,.272-.653,2.985,2.985,0,0,1-.851-2.3c3.281-.57,5.631-2.9,5.631-5.631a5.234,5.234,0,0,0-2.129-4.1,8.449,8.449,0,0,0-10.055,0A5.234,5.234,0,0,0,110.034,49.3Zm.767,0c0-2.755,2.866-5,6.39-5s6.39,2.241,6.39,5c0,2.428-2.218,4.5-5.273,4.919a.383.383,0,0,0-.33.406v0a3.766,3.766,0,0,0,.451,2.362,2.954,2.954,0,0,1-2.024-2.359v-.005a.383.383,0,0,0-.33-.406C113.019,53.794,110.8,51.725,110.8,49.3Z",
    transform: "translate(-1.073 -1.076)",
    fill: "#11526a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 6.998,
    cy: 6.998,
    r: 6.998,
    transform: "translate(845.533 564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.761,8.971,0,4.209.966,2.553l3.8,3.726L11.041,0l.966,1.656Z",
    transform: "translate(849 565.442)",
    fill: "#56af56"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotificationSmsSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_notification_sms_success.5c27df65.svg";
export { ForwardRef as ReactComponent };